export default "__VITE_ASSET__c668c321__"